import React, { useEffect, useState } from "react";
import SvgIcn from "../../../data/IconCompo";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Atomcs from "../../../styles/atoms.scss";
import { hideValidationPopup } from "../../../redux/actions";

function ValidationPopup({ text = "Validation successful!", icon, onClose }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const validationPopup = useSelector((state) => state.validationPopup);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleValidation = () => {
    setShowTooltip(true);
    setIsVisible(true);
    const hideId = setTimeout(() => {
      setShowTooltip(false);
      const doneId = setTimeout(() => {
        setIsVisible(false);
        dispatch(hideValidationPopup());
      }, 300); // Wait for the animation to finish
      return () => clearTimeout(doneId);
    }, 5000);
    return () => clearTimeout(hideId);
  };
  useEffect(() => {
    if (!validationPopup) return undefined;

    const scope = validationPopup.scopePath;
    if (scope && !location.pathname.startsWith(scope)) {
      return undefined;
    }

    return handleValidation();
  }, [dispatch, location.pathname, validationPopup]);
  return (
    <div>
      {isVisible && validationPopup.message && (
        <div
          className={`tooltip ${showTooltip ? "slide-down" : "slide-up"} ${
            validationPopup.type ? validationPopup.type : "info"
          }`}
        >
          {validationPopup.message}
          {validationPopup.icon && <SvgIcn name={validationPopup.icon} />}
        </div>
      )}
    </div>
  );
}

export default ValidationPopup;
